import { useEffect } from 'react'
import { useDispatch } from 'umi'
import goTo from '@/libs/functions/goTo'
import Layout from '@/libs/components/Layout'
import { getMemberInfo } from '@/services'
import checkOauth from '@/utils/checkOauth'

export default function levelZone() {
  const dispatch = useDispatch()

  const initData = async () => {
    const res: any = await getMemberInfo()
    const { levelId = '' } = res
    await checkOauth(levelId, 'section', window.location.hash.replace('#', ''))
    dispatch({
      type: `LevelZone/getData`,
      payload: {},
      callback: (levelType: 'equity' | 'product', templateType: string) => {
        goTo(
          `/memberEquity/levelZone/${
            levelType === 'equity' ? templateType || levelType : 'product'
          }`,
          {
            type: 'replace',
          },
        )
      },
    })
  }

  useEffect(() => {
    initData()
  }, [])
  return (
    <Layout title="加载中">
      <></>
    </Layout>
  )
}
